import {
  DocumentDTO,
  IntlCategoryDTO,
  IntlCategoryEntity,
  IntlSubcategoryDTO,
  IntlSubtitleDTO,
} from '@/services/content-api-types';

import { stateAtom } from '@/atoms';

type ConfirmationModalTypes =
  | 'categoryVisibility'
  | 'categoryDelete'
  | 'subcategoryVisibility'
  | 'subcategoryDelete'
  | 'sectionVisibility'
  | 'sectionDelete'
  | 'documentVisibility'
  | 'documentDelete';

export const {
  atom: adminStateAtom,
  focusState: focusAdminState,
  getState: getAdminState,
  setState: setAdminState,
  useState: useAdminState,
  useFocusState: useFocusAdminState,
} = stateAtom({
  editingCategory: undefined as IntlCategoryEntity | undefined,
  deleteModalState: {
    open: false,
    isFeatured: false,
    category: undefined as IntlCategoryEntity | undefined,
  },
  visibilityModalState: {
    open: false,
    isFeatured: false,
    category: undefined as IntlCategoryEntity | undefined,
    categoryIndex: undefined as number | undefined,
  },
  addRecommendedCategoryOpen: false,
  addCategoryOpen: false,
  temporaryCategory: {
    id: '',
    displayIndex: 0,
    enabled: false,
    featured: false,
    name: { en: '', es: '' },
    icon: '',
    subcategories: [],
  } as IntlCategoryDTO,
  selectedSubcategoryId: undefined as undefined | string,
  selectedSubcategoryIndex: -1,
  selectedSubcategory: null as IntlSubcategoryDTO | null,
  selectedSubtitleIndex: -1,
  selectedSubtitle: null as IntlSubtitleDTO | null,
  selectedDocumentIndex: -1,
  selectedDocument: null as DocumentDTO | null,
  confirmationModalType: null as ConfirmationModalTypes | null,
  showAddProcedurePopUp: false,
  isEditingSection: false,
  documentIsVisibleInSubtitle: false,
});
